import type { HttpVerbs } from "../types.ts";

export class NetworkError extends Error {
  readonly httpStatusCode = 0;
  /**
   * The requested verb when this error occurred.
   */
  readonly requestedMethod: HttpVerbs;
  /**
   * The requested url when this error occurred.
   */
  readonly requestedUrl: string;

  constructor(
    message: string,
    requestedMethod: HttpVerbs,
    requestedUrl: string,
  ) {
    super(
      `Requested resource: ${requestedMethod.toUpperCase()} ${requestedUrl}. ${message}`,
    );
    this.name = "NetworkError";
    this.requestedUrl = requestedUrl;
    this.requestedMethod = requestedMethod;
  }

  static is(obj: any): obj is NetworkError {
    return Boolean(obj && obj.name === "NetworkError");
  }
}
